const PUBLIC_DESCRIPTION = "مُبين: تسميع القرآن الكريم عن بُعد مع المعلم، من الجمعية الخيرية لتحفيظ القرآن الكريم بمحافظة رماح.";
const PORTAL_DESCRIPTION = "بوابة إدارة منصة مُبين للمشرفين ومديري المجمعات وإدارة الجمعية.";
const pub = (title, description = PUBLIC_DESCRIPTION) => ({
    title: `${title} | مُبين`,
    description,
});
const portal = (title) => ({
    title: `${title} | بوابة مُبين`,
    description: PORTAL_DESCRIPTION,
});
const PAGES = [
    [
        /^\/(download|join)$/,
        pub("حمّل تطبيق مُبين", "حمّل تطبيق مُبين للأندرويد أو جرّبه على الآيفون: تسميع القرآن الكريم مع معلمك، ومتابعة وردك وحضورك ونتائجك."),
    ],
    [
        /^\/volunteer$/,
        pub("تطوّع في تعليم القرآن الكريم", "علّم القرآن الكريم عن بُعد مع الجمعية الخيرية لتحفيظ القرآن الكريم بمحافظة رماح. قدّم طلب التطوع الآن."),
    ],
    [
        /^\/android-test$/,
        pub("جرّب تطبيق مُبين على أندرويد", "سجّل في فريق تجربة تطبيق مُبين على Google Play: ثلاث خطوات بسيطة تساعد الجمعية على نشر التطبيق للجميع."),
    ],
    [
        /^\/interview\/book$/,
        pub("اختر موعد مقابلتك", "رابط خاص لاختيار موعد مقابلة التطوع مع الجمعية الخيرية لتحفيظ القرآن الكريم بمحافظة رماح."),
    ],
    [
        /^\/interview\/room$/,
        pub("مقابلة التطوع", "مقابلة صوتية مع الجمعية الخيرية لتحفيظ القرآن الكريم بمحافظة رماح."),
    ],
    [/^\/privacy$/, pub("سياسة الخصوصية")],
    [/^\/terms$/, pub("شروط الاستخدام")],
    [/^\/account-deletion$/, pub("طلب حذف الحساب")],
    [/^\/login$/, portal("تسجيل الدخول")],
    [/^\/$/, portal("الرئيسية")],
    [/^\/branches$/, portal("المجمعات")],
    [/^\/circles$/, portal("الحلقات")],
    [/^\/circles\/[^/]+$/, portal("الحلقة")],
    [/^\/users$/, portal("المستخدمون")],
    [/^\/users\/[^/]+$/, portal("ملف المستخدم")],
    [/^\/join-requests$/, portal("طلبات الانضمام")],
    [/^\/new-students$/, portal("الطلاب الجدد")],
    [/^\/volunteers$/, portal("طلبات التطوع")],
    [/^\/interviews$/, portal("قاعة المقابلات")],
    [/^\/interview-slots$/, portal("مواعيد المقابلات")],
    [/^\/deletion-requests$/, portal("طلبات حذف الحساب")],
    [/^\/programs$/, portal("البرامج")],
    [/^\/policies$/, portal("سياسات البرامج")],
    [/^\/plan-preview$/, portal("معاينة الخطة")],
    [/^\/plans$/, portal("الخطط")],
    [/^\/recitation$/, portal("التسميع")],
    [/^\/exams$/, portal("الاختبارات")],
    [/^\/attendance$/, portal("الحضور")],
    [/^\/reports$/, portal("التقارير")],
    [/^\/notify$/, portal("إرسال إشعار")],
    [/^\/audit$/, portal("سجل التدقيق")],
    [/^\/roles$/, portal("الأدوار والصلاحيات")],
    [/^\/app-release$/, portal("تطبيق أندرويد")],
    [/^\/settings$/, portal("الإعدادات")],
];
/** The page's title and description, by its path (query string ignored). */
export function pageMeta(path) {
    const p = path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
    return PAGES.find(([re]) => re.test(p))?.[1] ?? { title: "مُبين", description: PUBLIC_DESCRIPTION };
}
//# sourceMappingURL=page-titles.js.map